import React from 'react';
import {ConfirmMessageIcon, ErrorMessageIcon} from "../assets/icons/Icons";
import "../assets/scss/components/message-file-validation.scss"

const MessageFileValidation = (props) => {
    return (
        <div className={`message-file-validation ${props.valid ? 'valid' : 'invalid'}`}>
            <div className="message-file-validation__left">
                <span className="message-file-validation__icon">
                    {props.valid ? <ConfirmMessageIcon/> : <ErrorMessageIcon/> }
                </span>
            </div>
            <div className="message-file-validation__right">
                <h4 className="message-file-validation__title">{props.valid ? 'File Validated.' : 'File error!'}</h4>
                <p className="message-file-validation__message">{props.message}</p>
            </div>
        </div>
    );
};

export default MessageFileValidation;
